/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { map } from 'rxjs';
import type { Observable } from 'rxjs';
@Injectable()
export class EncodingFixInterceptor implements HttpInterceptor {
  sanitize(value: any): any {
    if (typeof value === 'string') {
      return value
        .replace(/â€¢/g, '•')
        .replace(/â€“/g, '–')
        .replace(/â€”/g, '—')
        .replace(/â€™/g, '’')
        .replace(/â€œ/g, '“')
        .replace(/â€�/g, '”');
    } else if (Array.isArray(value)) {
      return value.map((v) => this.sanitize(v));
    } else if (value && typeof value === 'object') {
      for (const key of Object.keys(value)) {
        value[key] = this.sanitize(value[key]);
      }
    }
    return value;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event) => {
        if (event instanceof HttpResponse && event.body) {
          const cleanedBody = this.sanitize(event.body);
          return event.clone({ body: cleanedBody });
        }
        return event;
      })
    );
  }
}
